import { giphyBlack, giphyDarkGrey, giphyIndigo } from '@giphy/js-brand'
import { ReactNode } from 'react'
import styled from 'styled-components'
import { BORDER_RADIUS_MEDIUM } from '../constants'
import { UtilityButton } from './buttons'
import { Text, Title } from './typography'

const Content = styled.div`
    background: ${giphyBlack};
    border-radius: ${BORDER_RADIUS_MEDIUM}px;
    box-sizing: border-box;
    padding: 50px 40px;
    position: relative;
    text-align: center;
    width: 400px;
`

const Sticker = styled.img`
    display: block;
    height: 100px;
    margin: -100px auto 10px;
`

const Buttons = styled.div`
    display: flex;
    justify-content: center;
    margin: 30px auto 0;
    width: 300px;
`

const Button = styled(UtilityButton)`
    background: ${giphyDarkGrey};
    flex-shrink: 0;
    margin-right: 20px;
    padding: 0 15px;

    &:last-child {
        flex-shrink: 1;
        margin-right: 0;
        width: 100%;
    }
`

type Props = {
    className?: string
    children?: ReactNode
    stickerId?: string
    title: ReactNode
    description?: ReactNode
    primaryButtonLabel: ReactNode
    primaryButtonColor?: string
    secondaryButtonLabel?: ReactNode
    onPrimaryButtonClick: () => void
    onSecondaryButtonClick?: () => void
}

const CreationToolsAlertModal = ({
    className,
    children,
    stickerId,
    title,
    description,
    primaryButtonLabel,
    primaryButtonColor = giphyIndigo,
    secondaryButtonLabel,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
}: Props) => {
    return (
        <Content className={className}>
            {stickerId && <Sticker src={`//media.giphy.com/media/${stickerId}/200.gif`} alt="" />}
            <Title>{title}</Title>
            {description && <Text>{description}</Text>}
            {children}
            <Buttons>
                {secondaryButtonLabel && <Button onClick={onSecondaryButtonClick}>{secondaryButtonLabel}</Button>}
                <Button style={{ background: primaryButtonColor }} onClick={onPrimaryButtonClick}>
                    {primaryButtonLabel}
                </Button>
            </Buttons>
        </Content>
    )
}

export default CreationToolsAlertModal
